import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const fallbackPastors = [
  { name: 'Pastor Philip Rajkumar', title: 'Senior Pastor', bio: 'A servant of God with a heart for souls, Pastor Philip Rajkumar leads Zion Assembly with faith, prayer, and an unwavering commitment to the Word of God. His ministry has touched countless lives across the Nilgiris region.', photo_url: null },
  { name: 'Pastor Betty Suzanna', title: 'Associate Pastor', bio: "Pastor Betty Suzanna serves the congregation with grace and dedication, leading women's ministry, children's church, and pastoral care with the love and compassion of Christ.", photo_url: null },
];

function PastorCard({ pastor }) {
  return (
    <div className="card" style={{ padding: '36px 28px', textAlign: 'center' }}>
      {/* Circle photo */}
      <div style={{
        width: 140, height: 140,
        borderRadius: '50%',
        margin: '0 auto 22px',
        border: '4px solid var(--primary)',
        boxShadow: '0 0 0 6px rgba(201,168,76,0.12), 0 0 40px rgba(201,168,76,0.3)',
        background: 'rgba(201,168,76,0.08)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        overflow: 'hidden',
        flexShrink: 0,
      }}>
        {pastor.photo_url
          ? <img
              src={pastor.photo_url}
              alt={pastor.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }}
            />
          : <span style={{ fontSize: '3rem', color: 'var(--primary)', opacity: 0.4 }}>✝</span>
        }
      </div>
      <div style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '0.9rem', color: 'var(--text)', marginBottom: 6 }}>
        {pastor.name}
      </div>
      <div style={{ fontSize: '0.68rem', letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--primary)', marginBottom: 16 }}>
        {pastor.title}
      </div>
      <p style={{ fontFamily: "'Crimson Pro',serif", fontSize: '0.95rem', color: 'var(--text-muted)', lineHeight: 1.7 }}>
        {pastor.bio}
      </p>
    </div>
  );
}

export default function Pastors() {
  const [pastors, setPastors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPastors = async () => {
      const { data, error } = await supabase
        .from('pastors')
        .select('*')
        .order('display_order', { ascending: true });
      if (!error && data && data.length > 0) {
        setPastors(data);
      } else {
        setPastors(fallbackPastors);
      }
      setLoading(false);
    };
    fetchPastors();
  }, []);

  return (
    <section id="pastors" className="section" style={{ background: 'var(--bg-deep)' }}>
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ Spiritual Leadership</span>
          <h2 className="section-title">Meet Our <span>Pastors</span></h2>
          <div className="divider center" />
        </div>
        {loading ? (
          <div style={{ textAlign: 'center', color: 'var(--primary)', padding: '40px' }}>Loading… 🙏</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 28, maxWidth: 820, margin: '0 auto' }} className="pastors-grid">
            {pastors.map((p, i) => <PastorCard key={i} pastor={p} />)}
          </div>
        )}
      </div>
      <style>{`@media(max-width:600px){.pastors-grid{grid-template-columns:1fr!important}}`}</style>
    </section>
  );
}
